import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="bg-[#F6F7F8]">
      <div className="container mx-auto py-12 text-gray-800">
        <div className="max-w-4xl mx-auto bg-white my-16 p-6 md:p-10 rounded-lg">
          <h1 className="text-3xl md:text-4xl font-bold mb-2 text-center">
            Politique de Confidentialité – OuiGoo
          </h1>
          <p className="text-center text-gray-500 mb-8">
            Dernière mise à jour : 1er juillet 2025
          </p>

          <p className="mb-6">
            Merci de votre confiance. Chez Ozinex, éditeur de la plateforme OuiGoo, nous attachons une grande importance à la confidentialité de vos données.
          </p>
          <p className="mb-8">
            La présente Politique de confidentialité explique quelles données nous collectons, comment nous les utilisons, et comment nous les protégeons lorsque vous utilisez nos services (site, API, application Shopify, plugin WordPress, etc.).
          </p>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">1. Services couverts</h2>
            <p className="mb-4">Cette politique s’applique à tous les services proposés par OuiGoo, y compris :</p>
            <ul className="list-disc list-inside space-y-2 pl-4">
              <li>Notre tableau de bord business</li>
              <li>Notre API</li>
              <li>Notre application Shopify</li>
              <li>Notre plugin WordPress</li>
            </ul>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">2. Données que nous collectons</h2>
            <h3 className="text-xl font-semibold mb-3 mt-6">a) Données des marchands (utilisateurs OuiGoo)</h3>
            <p className="mb-4">Lorsque vous créez un compte ou utilisez nos services, nous pouvons collecter :</p>
            <ul className="list-disc list-inside space-y-2 pl-4">
              <li>Nom, prénom</li>
              <li>Adresse e-mail</li>
              <li>Numéro de téléphone</li>
              <li>Informations de connexion</li>
              <li>Informations sur vos commandes ou livraisons</li>
            </ul>

            <h3 className="text-xl font-semibold my-4 mt-6">b) Données des clients finaux (acheteurs)</h3>
            <p className="mb-4">Dans le cadre de la gestion de livraisons, nous pouvons recevoir ou afficher, à votre demande, certaines données de vos clients :</p>
            <ul className="list-disc list-inside space-y-2 pl-4">
              <li>Prénom et nom</li>
              <li>Adresse postale (livraison et facturation)</li>
              <li>Adresse e-mail</li>
              <li>Numéro de téléphone</li>
            </ul>
            <p className="mt-4 text-sm text-gray-600">
              Ces données ne sont affichées ou transmises que si vous utilisez une fonctionnalité qui les nécessite (Shopify, WordPress ou notre API), et uniquement dans le cadre de la gestion des livraisons.
            </p>

            <h3 className="text-xl font-semibold my-4 mt-6">c) Identifiant technique de devis</h3>
            <p className="mb-4">
              Lorsque vous demandez une estimation de livraison sur notre site, nous enregistrons dans le
              stockage local de votre navigateur (localStorage) un identifiant technique aléatoire
              (« identifiant d’appareil »). Il ne contient aucune donnée personnelle et sert uniquement à :
            </p>
            <ul className="list-disc list-inside space-y-2 pl-4">
              <li>relier vos différentes demandes de devis sur le même appareil ;</li>
              <li>vous éviter de ressaisir vos informations habituelles (préremplissage) ;</li>
              <li>mesurer et améliorer notre parcours de commande.</li>
            </ul>
            <p className="mt-4 text-sm text-gray-600">
              Vous pouvez le supprimer à tout moment en effaçant les données de navigation de votre navigateur.
            </p>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">3. Finalité de l’utilisation des données</h2>
            <p className="mb-4">Nous utilisons les données collectées uniquement pour les finalités suivantes :</p>
            <ul className="list-disc list-inside space-y-2 pl-4">
              <li>Création et gestion de votre compte OuiGoo</li>
              <li>Traitement des livraisons et commandes</li>
              <li>Affichage des informations utiles à la livraison dans le tableau de bord</li>
              <li>Fourniture d’interfaces automatisées (API, Shopify, WordPress)</li>
              <li>Communication et assistance client</li>
            </ul>
            <p className="mt-4 font-semibold bg-yellow-100 p-3 rounded-md">
              Aucune donnée n’est utilisée à des fins commerciales, marketing ou publicitaires sans consentement explicite.
            </p>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">4. Sécurité des données</h2>
            <p className="mb-4">Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles adaptées :</p>
            <ul className="list-disc list-inside space-y-2 pl-4">
              <li>Chiffrement des données en transit (HTTPS/TLS)</li>
              <li>Chiffrement des bases de données</li>
              <li>Accès restreint aux données</li>
              <li>Journaux d’accès</li>
              <li>Séparation stricte entre environnements de production et de test</li>
              <li>Sauvegardes sécurisées</li>
            </ul>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">5. Durée de conservation</h2>
            <p>Nous ne conservons les données que pour la durée nécessaire à la finalité du traitement (ex. : exécution des livraisons, gestion du compte). Au-delà, les données sont supprimées ou anonymisées de manière sécurisée.</p>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">6. Cas spécifiques par plateforme</h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-semibold mb-2">a) Application Shopify</h3>
                <p>Si vous utilisez notre app Shopify, nous accédons uniquement aux données nécessaires pour vous permettre de gérer les livraisons via le tableau de bord OuiGoo. Aucune donnée n’est utilisée à d’autres fins que la fourniture du service.</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2">b) Plugin WordPress</h3>
                <p>Notre module WordPress permet d’envoyer automatiquement les commandes vers OuiGoo. Nous n’utilisons aucune donnée du site WordPress à des fins tierces.</p>
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2">c) API</h3>
                <p>Notre API permet aux marchands d’intégrer leurs systèmes à OuiGoo. Toutes les données envoyées via l’API sont sous la responsabilité du marchand.</p>
              </div>
            </div>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">7. Vos droits</h2>
            <p className="mb-4">Si vous êtes un utilisateur de OuiGoo, vous pouvez à tout moment :</p>
            <ul className="list-disc list-inside space-y-2 pl-4">
              <li>Accéder à vos données</li>
              <li>Les modifier ou les corriger</li>
              <li>Demander leur suppression</li>
              <li>Retirer votre consentement à tout moment</li>
            </ul>
            <p className="mt-4">Pour exercer vos droits, vous pouvez nous contacter à l’adresse suivante : <a href="mailto:hello@ouigoo.co" className="text-primary-custom hover:underline">hello@ouigoo.co</a></p>
          </section>

          <hr className="my-8 border-gray-200" />

          <section className="mb-8" id="account-deletion">
            <h2 className="text-2xl font-semibold mb-4">8. Suppression de compte</h2>
            <p className="mb-4">
              Vous pouvez supprimer votre compte OuiGoo à tout moment, directement depuis l'application mobile :
            </p>
            <ol className="list-decimal list-inside space-y-2 pl-4 mb-4">
              <li>Ouvrez l'application <strong>OuiGoo Business</strong></li>
              <li>Accédez à <strong>Paramètres</strong></li>
              <li>Appuyez sur <strong>Mon compte</strong></li>
              <li>Sélectionnez <strong>Supprimer mon compte</strong></li>
              <li>Confirmez la suppression</li>
            </ol>
            <p className="mb-4">
              La suppression de votre compte entraîne l'effacement définitif de :
            </p>
            <ul className="list-disc list-inside space-y-2 pl-4 mb-4">
              <li>Vos informations personnelles (nom, email, téléphone)</li>
              <li>Votre historique de commandes et livraisons</li>
              <li>Vos adresses enregistrées</li>
              <li>Vos données de portefeuille</li>
              <li>Vos préférences et paramètres</li>
            </ul>
            <p className="mb-4 text-sm text-gray-600">
              Certaines données peuvent être conservées pendant une durée limitée pour des obligations légales ou comptables. Au-delà de cette période, elles sont définitivement supprimées.
            </p>
            <p>
              Si vous rencontrez des difficultés pour supprimer votre compte, contactez-nous à{' '}
              <a href="mailto:hello@ouigoo.co" className="text-primary-custom hover:underline">hello@ouigoo.co</a>.
            </p>
          </section>

          <hr className="my-8 border-gray-200" />

          <section>
            <h2 className="text-2xl font-semibold mb-4">9. Contact</h2>
            <p className="mb-4">Si vous avez des questions concernant cette politique ou vos données personnelles, veuillez nous contacter :</p>
            <div className="bg-gray-100 p-4 rounded-lg">
              <p className="font-semibold">Ozinex</p>
              <p>Service OuiGoo</p>
              <p><a href="mailto:hello@ouigoo.co" className="text-primary-custom hover:underline">hello@ouigoo.co</a></p>
              <p><a href="https://ouigoo.co" target="_blank" rel="noopener noreferrer" className="text-primary-custom hover:underline">ouigoo.co</a></p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
